import { render, staticRenderFns } from "./WordsLimitProgressBar.vue?vue&type=template&id=e775ac2a&"
import script from "./WordsLimitProgressBar.vue?vue&type=script&lang=js&"
export * from "./WordsLimitProgressBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e775ac2a')) {
      api.createRecord('e775ac2a', component.options)
    } else {
      api.reload('e775ac2a', component.options)
    }
    module.hot.accept("./WordsLimitProgressBar.vue?vue&type=template&id=e775ac2a&", function () {
      api.rerender('e775ac2a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/knowledge/components/WordsLimitProgressBar.vue"
export default component.exports